import * as React from "react";

import Button from "@mui/material/Button";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { renderEUDate } from "../../utils/utils";
import utc from "dayjs/plugin/utc";

function ButtonField(props) {
  const {
    setOpen,
    label,
    id,
    disabled,
    InputProps: { ref } = {},
    inputProps: { "aria-label": ariaLabel } = {},
  } = props;

  return (
    <Button
      variant="outlined"
      id={id}
      disabled={disabled}
      ref={ref}
      aria-label={ariaLabel}
      onClick={() => setOpen?.((prev) => !prev)}
    >
      {label ? `${label}` : "Seleziona una data"}
    </Button>
  );
}

function ButtonDP(props) {
  const [open, setOpen] = React.useState(false);

  const handleDateChange = (date) => {
    props.onChange(dayjs(date));
  };

  return (
    <DatePicker
      slots={{ field: ButtonField, ...props.slots }}
      slotProps={{ field: { setOpen } }}
      {...props}
      open={open}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      onChange={(date) => handleDateChange(date)}
    />
  );
}

export default function ButtonDatePicker({ value, onChange, id }) {
  return (
    <ButtonDP
      label={value ? renderEUDate(value) : "Seleziona Data"}
      value={value}
      id={id}
      onChange={onChange}
    />
  );
}
